import { MODAL_GA4_PROPERTY } from '@components/App/Modal/constants'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import type { AppState } from '@store/types'
import { ErrorNotification } from '@storeOld/reducers/notification'
import { closeModal } from '@storeOld/reducers/ui'
import { call, put, select } from 'redux-saga/effects'

import API from '@/api'
import { GtmTriggerName, sendGtmEvent } from '@/constants/gtm'
import type { Ga4Actions } from '../actions'
import { InternalGa4Actions } from '../actions'
import type { Ga4ReportStatus } from '../types'
import { fetchReport } from './fetchReport'
import { trackMetricsView } from './trackMetricsView'

export function* selectProperty({
  payload,
}: ReturnType<typeof Ga4Actions.selectProperty>) {
  const projectId: string | null = yield select(
    migrationProjectSelector.getProjectId
  )

  if (projectId === null) {
    return
  }

  yield put(InternalGa4Actions.savingProperty(true))

  try {
    yield call(API.GoogleAnalytics.selectProperty, projectId, payload)

    // Подключение завершено здесь: консент без выбора проперти цифр не даёт.
    sendGtmEvent(GtmTriggerName.ANALYTICS_CONNECT)

    // Кэш отчёта на бэке сброшен сменой проперти — забираем свежий.
    const status: Ga4ReportStatus | undefined = yield call(fetchReport)

    if (status !== 'ok') {
      yield put(
        ErrorNotification('Could not load Google Analytics data. Try again.')
      )

      return
    }

    yield call(trackMetricsView)

    // Keep the button loading until metrics are in the store. If the user
    // dismissed this modal meanwhile, do not close an unrelated dialog.
    const modalType: string = yield select(
      (state: AppState) => state.ui.modalType
    )

    if (modalType === MODAL_GA4_PROPERTY) {
      yield put(closeModal())
    }
  } catch {
    yield put(InternalGa4Actions.reportFailed('error'))
    yield put(
      ErrorNotification('Could not connect Google Analytics. Try again.')
    )
  } finally {
    yield put(InternalGa4Actions.savingProperty(false))
  }
}
